export enum CalendarViewsEnum {
    DATE = 'DATE',
    MONTH = 'MONTH',
    YEAR = 'YEAR'
}

export enum NavigationDirectionsEnum {
    PREV = 'PREV',
    NEXT = 'NEXT'
}
